import { 
    GET_CALENDAR_SETTINGS_SUCCESS
} from './constants';

const initialState = [];

/**
 *
 * @param state
 * @param action
 * @returns {(Array&{fonts: *})|(Array&{appearance: *[]})|Array|(Array&{appearance: null})|(Array&{appearance: ...*[]})}
 */
const settingsReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_CALENDAR_SETTINGS_SUCCESS:
            return {...state, ...action.calendarSettings};
            default:
                return state;
            }
};

export { settingsReducer as calendarSettings};